export const newRequestReducer = (state, action) => {
  switch (action.type) {
    case "set-sample-details-form":
      return {
        ...state,
        sampleDetailsForm: action.sampleDetailsForm,
      };
    case "set-item-list":
      return {
        ...state,
        itemList: action.itemList,
      };
    case "set-resubmit-sample-request-details":
      return {
        ...state,
        sampleRequestDetails: action.sampleRequestDetails,
      };
    case "set-is-submitting":
      return {
        ...state,
        isSubmitting: action.sampleDetails,
      };
    case "set-sample-request-form-display":
      return {
        ...state,
        sampleRequestFormDisplay: action.sampleRequestFormDisplay,
      };
    case "set-item-form-display":
      return {
        ...state,
        itemFormDisplay: action.itemFormDisplay,
      };
    case "set-item-form-to-edit":
      return {
        ...state,
        itemFormToEdit: action.itemFormToEdit,
      };
    default:
      throw new Error();
  }
};
